export function isSanitizeValue(value?: string): boolean {
  if (!value) return false;

  // 1. Supprimer les caractères invisibles non imprimables
  const cleaned = value
  .replace(/[\x00-\x1F\x7F]/g, "")

  // 2. Empêcher certains caractères qui pourraient être dangereux
  const forbiddenPattern = /[<>[\]{}.:"\\;]|--|\/\*|\*\/|script/i;

  // 3. Retourne true si aucun caractère interdit n'est détecté
  return !forbiddenPattern.test(cleaned);
}

export function isSanitizeEmailValue(value?: string): boolean {
  if (!value) return false;

  // 1. Supprimer les caractères invisibles non imprimables
  const cleaned = value
  .replace(/[\x00-\x1F\x7F]/g, "")

  // 2. Empêcher certains caractères qui pourraient être dangereux
  const forbiddenPattern = /[<>[\]{}:"\\;]|--|\/\*|\*\/|script/i;

  // 3. Retourne true si aucun caractère interdit n'est détecté
  return !forbiddenPattern.test(cleaned);
}

export function isSanitizeMessageContactValue(value?: string): boolean {
  if (!value) return false;

  // 1. Supprimer les caractères invisibles non imprimables
  const cleaned = value
  .replace(/[\x00-\x1F\x7F]/g, "")

  // 2. Empêcher certains caractères qui pourraient être dangereux
  const forbiddenPattern = /[<>[\]{}\\]|--|\/\*|\*\/|script/i;

  // 3. Retourne true si aucun caractère interdit n'est détecté
  return !forbiddenPattern.test(cleaned);
}

export function isSanitizeMessageChatValue(value?: string): boolean {
  if (!value) return false;

  // 1. Supprimer les caractères invisibles non imprimables
  const cleaned = value
  .replace(/[\x00-\x1F\x7F]/g, "")

  // 2. Empêcher certains caractères qui pourraient être dangereux
  const forbiddenPattern = /[<>[\]{}\\]|--|\/\*|\*\/|script/i;

  // 3. Retourne true si aucun caractère interdit n'est détecté
  return !forbiddenPattern.test(cleaned);
}

export function isSanitizeContentShareExpValue(value?: string): boolean {
  if (!value) return false;

  // 1. Supprimer les caractères invisibles non imprimables
  const cleaned = value
  .replace(/[\x00-\x1F\x7F]/g, "")

  // 2. Empêcher certains caractères qui pourraient être dangereux
  const forbiddenPattern = /[<>[\]{}\\]|--|\/\*|\*\/|script/i;

  // 3. Retourne true si aucun caractère interdit n'est détecté
  return !forbiddenPattern.test(cleaned);
}